// IE 2026 10 22 / ODOO-5800 (unsaved; Igor 22.10, стол 0af_001, page-ex-plan-market: «после внесения корректировки, до ещё записи в базу, можно ли визуализировать в форме ячейки
// уже актуальные столбики и графики версий в плане и отклонения от того, что сверху, снизу, что на текущем уровне»): незаписанные правки грида → params.overrides запроса паспорта
// ячейки (бэк common_modules/plan_cell_passport.overrides_in / apply_overrides / apply_versions_overrides). Чистые функции без Vue и DOM (юнит tests/unit/cellPassportOverrides.test.mjs).
//
// Источник правок — undo-стек грида (AttrGrid.undoStack: {method 'val', $item, col_binding 'YYYY-MM-DD.<мера>' | 'data::…', val (до), newVal, indirect?}) — то же, что читает
// Save (plan_rows_save.parse_stack); косвенные (indirect) правки агрегатов не шлются. Повтор одной ячейки — первое «до» и последнее «после». Правка СУММЫ (amount) несёт
// количество строки после онлайн-пересчёта (dataItem[<месяц>].quantity | .value, исходное — dataItem._xpl_orig[<месяц>].quantity — модуль ieXPL_online_recalc); при правке
// и количества, и суммы одной ячейки-месяца — только количество (иначе delta удвоится). dims — отборы строки и предков (whereOf(item) → [[ключ, значение], …] как where паспорта),
// self — строка открытой ячейки.

export const OVERRIDE_MEASURES = ['quantity', 'value', 'amount']
export const OVERRIDES_MAX = 400
const BIND_RE = /^(?:data::)?(\d{4}-\d{2})-\d{2}\.([A-Za-z_][\w]*)$/

const num = (v) => (v === null || v === undefined || v === '' || typeof v === 'boolean') ? null : (Number.isFinite(Number(v)) ? Number(v) : null)

// привязка колонки → {month 'YYYY-MM', measure} | null
export function cellPassport_bindingOf(col_binding) {
    const m = BIND_RE.exec(String(col_binding || ''))
    if (!m || !OVERRIDE_MEASURES.includes(m[2])) return null
    return { month: m[1], measure: m[2] }
}

// undoStack → [{month, measure, value, before, dims, self, qty?, qty_before?}] (пусто — правок нет)
export function cellPassport_overrides(undoStack, { dataItem = null, whereOf = null, max = OVERRIDES_MAX } = {}) {
    const byKey = new Map()   // item|month|measure → {item, month, measure, before, value}
    for (const rs of (Array.isArray(undoStack) ? undoStack : [])) {
        if (!rs || typeof rs !== 'object' || rs.indirect || (rs.method && rs.method !== 'val')) continue
        const item = rs.$item || rs.item
        if (!item || typeof item !== 'object') continue
        const b = cellPassport_bindingOf(rs.col_binding || rs.binding)
        if (!b) continue
        const key = [b.month, b.measure].join('|')
        let per = byKey.get(item)
        if (!per) { per = new Map(); byKey.set(item, per) }
        const cur = per.get(key)
        if (cur) cur.value = rs.newVal
        else per.set(key, { item, month: b.month, measure: b.measure, before: num(rs.val), value: rs.newVal })
    }
    const out = []
    for (const [item, per] of byKey) {
        const months = new Set([...per.values()].map(e => e.month))
        for (const month of months) {
            const q = per.get(month + '|quantity') || per.get(month + '|value')
            const e = q || per.get(month + '|amount')   // количество сильнее суммы (сумма уже пересчитана в количество онлайн-модулем)
            if (!e) continue
            const value = num(e.value)
            if (value === null) continue   // очищена — бэк такую правку не применяет
            let dims = {}
            try { for (const p of (typeof whereOf === 'function' ? (whereOf(item) || []) : [])) if (Array.isArray(p) && p[0] && p[1] !== undefined && p[1] !== null && p[1] !== '') dims[String(p[0])] = p[1] } catch (err) { dims = {} }
            const o = { month: e.month, measure: e.measure, value, before: e.before, dims, self: item === dataItem }
            if (e.measure === 'amount') {
                const row = item[e.month + '-01'] || item['data::' + e.month + '-01'] || {}
                const qty = num(row.quantity ?? row.value)
                if (qty === null) continue   // суммы без количества бэк не считает
                o.qty = qty
                const orig = item._xpl_orig && item._xpl_orig[e.month + '-01']
                o.qty_before = orig ? num(orig.quantity ?? orig.value) : null
            }
            out.push(o)
            if (out.length >= max) return out
        }
    }
    return out
}

// пометка «незбережено» для подписи: {delta, saved} бэка → '+10 000' / '−500' (fmt — форматтер чисел формы); пусто — ''
export function cellPassport_unsavedText(u, fmt) {
    const d = u && typeof u === 'object' ? num(u.delta) : null
    if (d === null || !d) return ''
    const f = typeof fmt === 'function' ? fmt : (x) => String(x)
    return (d > 0 ? '+' : '−') + f(Math.abs(d))
}
